<template>
    <div>
        <div class="results grey lighten-5 mb-6">
            <h2>Your crystals for {{ results | readable }}</h2>
            <div class="row">
                <div class="column" v-for="(result, index) in getMatches(results)" :key="index">
                    <div class="card pa-2">
                        <h3>{{ result.name }}</h3>
                        <img :src="result.image" :alt="result.name" />
                        <h4>For {{ result.matches | readable}}</h4>
                        <a class="btn" target="_blank" :href="result.url">Buy now</a>
                    </div>
                </div>
            </div><!--/.row -->
        </div>
    </div>
</template>

<script>
export default {
  /* Child component registration */
  components: {
    //
  },

  /* Properties */
  props: ["chosen_crystals"],
  /* Component's local data */

  data() {
    return {
      results: this.chosen_crystals,
      // results: ["Abundance", "Courage", "Healing"],
      crystals: [
      {
          name: "Amazonite",
          keywords: ["Abundance", "Balance", "EMF Protection", "Healing"],
          url: "/product/amazonite-tumblestone/",
          image: "/wp-content/uploads/2020/08/Amazonite-Final-1.png"
      },
      {
          name: "Green Jade",
          keywords: ["Abundance", "Harmony", "Peace", "Sleep"],
          url: "/product/green-jade-tumblestone/",
          image: "/wp-content/uploads/2020/08/Green-Jade-1-1.png"
      },
      {
          name: "Sunstone",
          keywords: ["Abundance", "Courage", "Healing", "Joy"],
          url: "/product/sunstone-tumblestone/",
          image: "/wp-content/uploads/2020/08/Sunstone-1.png"
      },
      {
          name: "Sodalite",
          keywords: ["Anxiety", "Relief", "Focus", "Sodalite", "Stress Relief"],
          url: "/product/sodalite-tumblestone/",
          image: "/wp-content/uploads/2020/08/Sodalite-1.png"
      },
      {
          name: "Howlite",
          keywords: [
          "Anxiety",
          "Relief",
          "Calm",
          "Empowerment",
          "Focus",
          "Patience"
          ],
          url: "/product/howlite-tumblestone/",
          image: "/wp-content/uploads/2020/08/Howlite-1.png"
      },
      {
          name: "Rose Quartz",
          keywords: [
          "Anxiety",
          "Relief",
          "Calm",
          "Forgiveness",
          "Love",
          "Patience"
          ],
          url: "/product/rose-quartz/",
          image: "/wp-content/uploads/2020/08/Rose-Quartz-1-1.png"
      },
      {
          name: "Labradorite",
          keywords: ["Cleansing", "Intuition", "Strength", "Transformation"],
          url: "/product/labradorite-tumblestone/",
          image: "/wp-content/uploads/2020/08/Labradorite-1.png"
      },
      {
          name: "Amethyst",
          keywords: ["Balance", "Forgiveness", "Growth", "Harmony", "Release"],
          url: "/product/chevron-amethyst-tumblestone/",
          image: "/wp-content/uploads/2020/08/Amethyst-Final-1.png"
      },
      {
          name: "Blue Lace Agate",
          keywords: ["Balance", "Cleansing", "Peace", "Stress Relief"],
          url: "/product/blue-lace-agate-tumblestone/",
          image: "/wp-content/uploads/2020/08/Blue-Lace-Agate-Final-2a.png.jpg"
      },
      {
          name: "Moonstone",
          keywords: ["Balance", "Calm", "Intuition", "Release", "Stress Relief"],
          url: "/product/moonstone-tumblestone/",
          image: "/wp-content/uploads/2020/08/Moonstone-1-1.png"
      },
      {
          name: "Manifestation Quartz",
          keywords: ["Clarity", "Happiness", "Joy", "Manifestation"],
          url: "/product/manifestation-quartz-tumblestone/",
          image: "/wp-content/uploads/2020/08/Manifestation-Quartz-1-Large.png"
      },
      {
          name: "Clear Quartz",
          keywords: ["Clarity", "Cleansing", "Healing", "Manifestation"],
          url: "/product/clear-quartz-tumblestone/",
          image: "/wp-content/uploads/2020/08/Clear-Quartz-Final-1.png"
      },
      {
          name: "Smoky Quartz",
          keywords: ["Calm", "Cleansing", "Detox", "EMF Protection"],
          url: "/product/smoky-quartz-tumblestone/",
          image: "/wp-content/uploads/2020/08/Smokey-Quartz-1.png"
      },
      {
          name: "Malachite",
          keywords: ["Confidence", "Courage", "Empowerment", "Protection"],
          url: "/product/malachite-tumblestone/",
          image: "/wp-content/uploads/2020/08/Malachite-1.png"
      },
      {
          name: "Green Aventurine",
          keywords: ["Confidence", "Love", "Motivation", "Sleep"],
          url: "/product/green-aventurine-tumblestone/",
          image: "/wp-content/uploads/2020/08/Green-Aventurine-1.png"
      },
      {
          name: "Carnelian",
          keywords: ["Confidence", "Courage", "Empowerment", "Motivation"],
          url: "/product/carnelian-tumblestone/",
          image: "/wp-content/uploads/2020/08/Carnelian-Final-1a.png"
      },
      {
          name: "Red jasper",
          keywords: ["Courage", "Grounding", "Healing", "Stress Relief"],
          url: "/product/red-jasper-tumblestone/",
          image: "/wp-content/uploads/2020/08/Red-Japer-1a.png"
      },
      {
          name: "Black tourmaline",
          keywords: [
          "Detox",
          "EMF Protection",
          "Grounding",
          "Joy",
          "Transformation"
          ],
          url: "/product/black-tourmaline-tumblestone/",
          image: "/wp-content/uploads/2020/08/Black-Tourmaline-Final-1.png"
      },
      {
          name: "Shungite",
          keywords: ["EMF Protection", "Growth", "Sleep", "Transformation"],
          url: "/product/shungite-tumblestone/",
          image: "/wp-content/uploads/2020/08/Shungite-1.png"
      },
      {
          name: "Garnet",
          keywords: ["Detox", "Empowerment", "Harmony", "Love", "Strength"],
          url: "/product/garnet-tumblestone/",
          image: "/wp-content/uploads/2020/07/garnet-2.jpg"
      },
      {
          name: "Tiger Iron",
          keywords: ["Clarity", "Focus", "Harmony", "Manifestation"],
          url: "/product/tiger-iron-tumblestone/",
          image: "/wp-content/uploads/2020/08/Tigers-Iron-1-.png"
      },
      {
          name: "Sardonyx",
          keywords: ["Focus", "Happiness", "Love", "Protection"],
          url: "/product/sardonyx-tumblestone/",
          image: "/wp-content/uploads/2020/08/Sardonyx-1.png"
      },
      {
          name: "Black Onyx",
          keywords: ["Anxiety", "Relief", "Happiness", "Release", "Strength"],
          url: "/product/black-onyx-tumblestone/",
          image: "/wp-content/uploads/2020/08/Black-Onyx-Final-1.png"
      },
      {
          name: "Blue Goldstone",
          keywords: ["Growth", "Motivation", "Positivity", "Strength"],
          url: "/product/blue-goldstone/",
          image: "/wp-content/uploads/2020/08/blue-goldstone-3.png"
      },
      {
          name: "Bronzite",
          keywords: ["Growth", "Happiness", "Manifestation", "Positivity"],
          url: "/product/bronzite-tumblestone/",
          image: "/wp-content/uploads/2020/08/Bronzite-1-Final.png"
      },
      {
          name: "Snowflake Obsidian",
          keywords: ["Detox", "Grounding", "Intuition", "Protection"],
          url: "/product/snowflake-obsidian/",
          image: "/wp-content/uploads/2020/08/Snowflake-Obsidian-1a.png"
      },
      {
          name: "Petrified Wood",
          keywords: [
          "Forgiveness",
          "Patience",
          "Peace",
          "Protection",
          "Transformation"
          ],
          url: "/product/petrified-wood-tumblestone/",
          image: "/wp-content/uploads/2020/08/Petrified-Wood-1.png"
      },
      {
          name: "Unakite",
          keywords: ["Forgiveness", "Patience", "Positivity", "Release"],
          url: "/product/unakite-tumblestone/",
          image: "/wp-content/uploads/2020/08/Unakite-1.png"
      },
      {
          name: "Citrine",
          keywords: [
          "Abundance",
          "Clarity",
          "Confidence",
          "Joy",
          "Motivation",
          "Relief"
          ],
          url: "/product/citrine-tumblestone/",
          image: "/wp-content/uploads/2020/08/Citrine-Final-2b.png"
      }
    ]
    };
  },
  /* Watchers */
  watch: {
    //
  },

  /* Computed properties */
  computed: {},

  /* Component methods */
  methods: {
    // Abundance, Courage & Healing
    getMatches: function(chosenWords) {
      let wordsToFind = chosenWords;
      let crystals = this.crystals;

      /**
      Loop over the array of crystal objects:
        {
          name: "Green Jade",
          keywords: ["Abundance", "Harmony", "Peace", "Sleep"]
        }
      on each iteration of map we work on a (crystal):
      1. create a wordsFound variable, by filtering wordsToFind for any matches on the array in crystal.keywords
      2. check if the wordsFound is 3, which means its the perfect crystal match. If it is, filter down wordsToFind to nothing.
      3. return the crystal back into the map, which will look like:
        [{
          name: 'Green Jade',
          matches: ["Abundance", "Harmony", "Peace"]
        }]
      As we are checking for a wordsFound.length of 3, this map function will only ever return a perfect match, or nothing.
      */
      const perfectMatch = crystals
        .map(function(crystal) {
          let wordsFound = wordsToFind.filter(function(chosenWord) {
            if (crystal.keywords.indexOf(chosenWord) !== -1) {
              return true;
            }
          });
          if (wordsFound.length === 3) {
            wordsToFind = wordsToFind.filter(function(word) {
              return wordsFound.indexOf(word) === -1;
            });
          }
          return {
            name: crystal.name,
            matches: wordsFound,
            url: crystal.url,
            image: crystal.image
          };
        })
        /**
        We need to filter this map array down to 1 crystal, in order to return it to mainCrystal, 
        so we check fthe crystal.matches property on each crystal, and only let through if === 3
        */
        .filter(function(crystal) {
          return crystal.matches.length === 3;
        });
        // If there is a perfect match, stop here and return it, as getMatches has done its job.
        if (perfectMatch.length > 0) return perfectMatch;

        /** 
        If we haven't found a perfect crystal, do the same process again by searching crystals, 
        but this time relax the rule to 1 OR 2 keyword matches.
        */
        const matchTwo = crystals
          .map(function(crystal) {
            let wordsFound = wordsToFind.filter(function(chosenWord) {
              if (crystal.keywords.indexOf(chosenWord) !== -1) {
                return true;
              }
            });
          // Check cystal to see if it matches on TWO words
          if (wordsFound.length === 2) {
            wordsToFind = wordsToFind.filter(function(word) {
              return wordsFound.indexOf(word) === -1;
            });
          }
          return {
            name: crystal.name,
            matches: wordsFound,
            url: crystal.url,
            image: crystal.image
          };
        })
        .filter(function(crystal) {
          return crystal.matches.length === 2;
        });

        /**
        At this point, we either have a matchOnTwo array containing 1 crystal object, or nothing, so we need to continue to find the remaining 2 matches, or all 3.
        */
        const matchOne = crystals
          .map(function(crystal) {
            let wordsFound = wordsToFind.filter(function(chosenWord) {
              if (crystal.keywords.indexOf(chosenWord) !== -1) {
                return true;
              }
            });
            // Check cystal to see if it matches on TWO words
            if (wordsFound.length === 1) {
              wordsToFind = wordsToFind.filter(function(word) {
                return wordsFound.indexOf(word) === -1;
              });
            }
            return {
              name: crystal.name,
              matches: wordsFound,
              url: crystal.url,
              image: crystal.image
            };
          })
          .filter(function(crystal) {
            return crystal.matches.length === 1;
          });
        return matchTwo.concat(matchOne);
    }
  },

  filters: {
    readable: function(value) {
      if (!value) return "";
      let output = value[0];
      if (value.length === 3) output += ", " + value[1] + " & " + value[2];
      if (value.length === 2) output += " & " + value[1];
      return output;
    }
  },

  /* Vue lifecycle hooks:
  Ref: https://vuejs.org/v2/guide/instance.html#Instance-Lifecycle-Hooks
 */
  created: function() {
    //
  },
  mounted() {},
  updated() {},
  destroyed() {}
};
</script>

<style lang="scss">
    .results {
      margin-top: -60px;
      
      h2 {
        color: #000000;
        font-size: 20px;
        font-weight: 400;
        text-transform: uppercase;
        letter-spacing: 6.5px;
        text-align: center;
        margin: 0 0 3rem 0;
      }
    }
    .row {
        display: flex;
        justify-content: space-around;
        max-width: 90%;
        margin: 0 auto;
        flex-wrap: wrap;

        .column {

          display: flex;
          flex-grow: 1;
          justify-content: center;

          @media (min-width: 576px) {
            max-width: 32%;
          }

          .card {

              width: 100%;

              h3 {
                  color: #89917C;
                  text-align: center;
                  font-size: 20px;
                  font-weight: 400;
                  text-transform: uppercase;
                  line-height: 1.4em;
                  letter-spacing: 6.5px;
                  min-height: 56px;
              }

              h4 {
                text-align: center;
                line-height: 1.75rem;
                min-height: 56px;
                margin: 1rem auto;
              }

              img {
                  width: 100%;
                  height: auto;
              }

              .btn {
                padding: 15px 30px;
                width: auto;
                font-size: 22px;
                font-weight: 400;
                fill: #FFFFFF;
                color: #FFFFFF;
                background-color: #000000;
                border-radius: 0px 0px 0px 0px;
                box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.07);
                margin: 0 auto;
                display: block;
                width: max-content;
              }
          }
        }


    }
</style>

